export default {
    "slug": "hell",
    "title": "Hellwards",
    "firstChapterKey": "wrath",
    "chapters": {
        "wrath": require("./wrath").default,
        "sorrow": require("./sorrow").default,
        "avarice": require("./avarice").default,
        "gluttony": require("./gluttony").default,
	},
    "configuration": {
        "darkness": true,
        "squigglevision": true,
    },
    "player": {
        "affiliation": "good",
        "inventory": {
            "gold": 0,
            "items": {},
        },
        "perks": [],
        "party": {
            "units": {
                "swordlord": {
                    "key": "swordlord",
                    "jobKey": "sword",
                    "affiliation": "good",

                    "isRecruited": true,

                    "maxhealth": 25,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "rally",
                        "recruit",
                    ],

                    "name": "Errant",
                    "jobName": "Swordlord",
                    "faceKey": "knight",
                    "bodyKey": "good",
                },
                "spearknight": {
                    "key": "spearknight",
                    "jobKey": "spearknight",
                    "affiliation": "good",

                    "maxhealth": 35,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "swap",
                        "recruit",
                    ],

                    "name": "Constance",
                    "jobName": "Shieldknight",
                    "faceKey": "human",
                    "bodyKey": "good",

                    "facts": [
                        "Can only move 1 square a turn, but has high defense.",
                    ]
                },
                "axeknight": {
                    "key": "axeknight",
                    "jobKey": "hammercavalier",
                    "affiliation": "good",

                    "maxhealth": 25,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "smite",
                        "recruit",
                    ],

                    "name": "Runaway",
                    "faceKey": "human",
                    "bodyKey": "good",

                    "facts": [
                        "Can move 3(!) squares a turn!",
                        // "Can push an ally 1 square.",
                    ]
                },
                "highpriest": {
                    "key": "highpriest",
                    "jobKey": "priest",
                    "affiliation": "good",

                    "maxhealth": 15,
                    "defense": 1,
                    "skills": [
                        "inflict-damage",
                        "restore-health",
                        "recruit",
                    ],

                    "name": "Worry",
                    "faceKey": "human",
                    "bodyKey": "good",

                    "facts": [
                        "Can heal close-range OR attack far-range.",
                    ]
                },
                "daggercloak": {
                    "key": "daggercloak",
                    "jobKey": "dagger",
                    "affiliation": "good",

                    "maxhealth": 20,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "pull",
                        "recruit",
                    ],

                    "name": "Abandon",
                    "faceKey": "human",
                    "bodyKey": "good",

                    "facts": [
                        "Can attack from 2 squares away.",
                    ]
                },
                "gunner": {
                    "key": "gunner",
                    "jobKey": "gun",
                    "affiliation": "good",

                    "maxhealth": 20,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "smite",
                        "recruit",
                    ],

                    "name": "Pig",
                    "faceKey": "human",
                    "bodyKey": "good",

                    "facts": [
                        "Has a gun.",
                    ]
                },
            }
        },
    }
}
